// extracted by mini-css-extract-plugin
export default {"logoWrapper":"CompanyLogo_logoWrapper__OvwpI"};